import styled from 'styled-components';
import { ButtonLabel, ButtonWrapper } from '@src/styles/styled/mixins';
import { Tabs } from 'antd';

export const DimensionTablesWrapper = styled.div`
  flex-direction: column;
  flex-grow: 1;
  display: flex;
`;

export const DimensionWidget = styled.div`
    display: flex;
    flex-direction: column;
`;

export const DimensionWidgetWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2.5px 0px;
    box-sizing: border-box;
    height: fit-content;
    padding: 5px 0px;
    min-height: 200px;
    flex-grow: 1;
    flex-basis: 100%;
    position: relative;
`;

export const DimensionTableContainer = styled.div<{ width: number }>`
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
  flex-grow: 1;
  justify-content: space-between;
  height: fit-content;
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  overflow: hidden;
  width: auto;
  display: grid;
  grid-template-columns: ${(props) => `repeat(auto-fill,minmax(${props.width}px, 1fr))` };
  grid-auto-rows: 47px;
  gap: 10px;
`;

export const HeaderFlexWrap = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 2px;
  flex-direction: column;
  position: sticky;
  top: 0px;
  z-index: 9;
  background-color:#F5F5F5;
  padding-bottom: 3px;
`;

export const TitleFlexWrap = styled.div`
  flex-grow:1;
  display:flex;
  flex-direction:row;
  flex-wrap: wrap;
  align-items: center;
  padding: 0px;
  background-color: #ECECEC;
  margin-bottom: 5px;
`;

export const ViewToggleWrapper = styled.div`
  padding: 5px;
  input:active + label, input:hover + label, label:active, label:hover {
    border-color: #ddd;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    width: 0px;
  }
  .ant-radio-button-wrapper {
    border: 1px solid #ddd;
  }
  .ant-radio-button-wrapper:focus-within {
    outline: none;
  }
`;

export const ViewerSessionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  min-height: 600px;
`;

export const VMTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  padding: 10px;
  gap: 10px;
`;

export const WarningText = styled.div`
  margin: 10px;
  font-size: 16px;
`;


export const StyledImpactedToolbarWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0;
`;

export const StyledBtnWrapper = styled.div`
  ${ButtonWrapper}
`;

export const StyledBtnLabel = styled.div`
  ${ButtonLabel}
`;

export const SliceIntervalWrapper =  styled.div<{ color: string }>`
  display: flex;
  alignItems: center;
  border: 1px solid #c9cbcd;
  background-color: white;
  border-radius: 6px;
  border-left:  ${(props) => `solid 10px ${props.color}` };
`;

export const SlicePositionWrapper = styled.div<{}>`
  display: flex;
  position: absolute;
  right: 0px;
  top: 15px;
`;


export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0px;
    border-bottom: 1px solid #E5E5E5;
  }
`;
